// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Player_videoWrapper_3OWx6"};